import { SelectFilter } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  updateFilterState: (value: Record<string, string>) => void
}

export const CallSignFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation('dashboard')

  const options = [
    { label: t('significantUser'), value: 'true' },
    { label: t('notSignificantUser'), value: 'false' },
  ]

  return (
    <SelectFilter
      placeholder={t('sign')}
      options={options}
      onChange={(is_user_significant_flag) => updateFilterState({ is_user_significant_flag })}
      value={value}
      showSearch={false}
    />
  )
}
